import React from 'react'
import styles from './SingleSelect.module.css'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

function SingleSelect({ data, field, label, onChange, options, placeholder = "", width = null, isDisabled = false }) {
    return (
        <FormControl
            sx={{
                height: 24,
                border: 'none',
                borderRadius: 1,
                '& .MuiOutlinedInput-root': {
                    height: '-webkit-fill-available',
                    width: width || '179px',
                    border: 'none',
                    '& fieldset': {
                        borderColor: '#9F9F9F',
                    },
                    '&:hover fieldset': {
                        border: '1px solid #9F9F9F',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '1px solid #9F9F9F',
                    },
                },
            }}
        >
            <InputLabel
                id="demo-simple-select-label"
                shrink={false}
                className={styles.reasonInputLabel}
                sx={{
                    display: data[field]?.trim() ? 'none' : 'initial',  // Fix: Ensuring empty string does not hide label
                    position: data[field]?.trim() ? 'none' : 'absolute',
                    top: '50%',
                    left: '10px',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                }}
            >
                {label}
            </InputLabel>
            <Select
                id="select-for-change-reason"
                labelId="demo-simple-select-label"
                className={styles.reasonForChangeField}
                value={data[field] !== ' ' ? data[field] : ''}
                onChange={(val) => {
                    if (!val.target.value.includes('Others')) {
                        onChange(val.target.value);
                    }
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            border: '1px solid #9F9F9F',
                            borderRadius: '5px',
                            boxShadow: '0px 4px 8px 0px #959DA533',
                        },
                    },
                }}
                displayEmpty
                renderValue={(selected) => {
                    if (selected === '') {
                        return placeholder;
                    }
                    return selected;
                }}
                disabled={isDisabled}
            >
                {/* <MenuItem value="">{placeholder}</MenuItem> */}
                {options.map((opt, ind) => (
                    <MenuItem key={`${opt}_${ind}`} onClick={() => {
                        if (opt.includes('Others')) {
                            onChange(opt)
                        }
                    }} value={opt} className={styles.reasonInputLabel} title={opt}
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "200px",
                            display: 'block'
                        }}>{opt}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default SingleSelect;